import request from '@/utils/http';
// 在途跟踪列表数据
export const getTranckingList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/getEtDispatchOrderItem`,
        method: 'get',
        params
    });
};

// 在途时效预警列表数据
export const getWarningList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/loadTransitTracking`,
        method: 'get',
        params
    });
};

// 在途跟踪-定位
export const locate = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/locate`,
        method: 'post',
        data
    });
};

// 在途跟踪-到达回显弹窗的站点updateEttaStatus
export const getStopsList = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getStopsList`,
        method: 'post',
        data
    });
};

// 在途跟踪-到达弹窗确认
export const updateEttaStatus = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/updateEttaStatus`,
        method: 'post',
        data
    });
};

// 在途跟踪-双击查看详情
export const getOrderDetailsByEtdoNo = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getOrderDetailsByEtdoNo`,
        method: 'post',
        data
    });
};

// 在途跟踪-双击查看详情-历史跟踪记录
export const saveRansitHislItems = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveRansitHislItems`,
        method: 'post',
        data
    });
};

// 在途跟踪-双击查看详情-异常信息删除
export const removeTransitTrackingByPk = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/removeTransitTrackingByPk`,
        method: 'post',
        data
    });
};

// 在途时效预警-双击保存
export const saveTransitTracking = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveTransitTracking`,
        method: 'post',
        data
    });
};

// 根据code从数据字典获取
export const getDictionaryDetailByCode = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};

// 在途跟踪-双击查看详情-历史跟踪记录-新增异常信息
export const saveTransitTrackingItem = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveTransitTrackingItem`,
        method: 'post',
        data
    });
};

// 在途可视化-搜索
export const getCoordinates = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getCoordinates`,
        method: 'post',
        data
    });
};